'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFunction;

/**
 * Checks if given variable is a function
 *
 * @param {*} functionToCheck
 * @returns {boolean}
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}


//////////////////
// WEBPACK FOOTER
// ./~/kompo-util/lib/isFunction.js
// module id = 22
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11